import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

type ReactPortalProps = {
  children: React.ReactNode;
  wrapperId: string;
};

export const ReactPortal = ({ children, wrapperId }: ReactPortalProps) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(
    null
  );

  useLayoutEffect(() => {
    const owner = `portal-${wrapperId}-${Math.random().toString(36).slice(2)}`;
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId, owner);
    }
    setWrapperElement(element);

    return () => {
      if (systemCreated && element?.dataset.owner === owner) {
        element.remove();
      }
    };
  }, [wrapperId]);

  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};

function createWrapperAndAppendToBody(wrapperId: string, owner: string) {
  const wrapperElement = document.createElement("div");
  wrapperElement.setAttribute("id", wrapperId);
  wrapperElement.dataset.owner = owner;
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}
